import _ from "lodash";
import { CLEAR_OFFERS, OFFERS_UPDATED } from "../actions/types";
import { MarketingCampaignType, Offer } from "../../1_types/genericTypes";
import { isBngmOptionListOffer } from "../../utils/bngmOffer";
import { getOfferConfigProducts } from "../../utils/marketingCampaign";

type OfferReducerState = {
  productOffers: Offer[];
  thresholdOffer: Offer;
  bngmOffers: Offer[];
};

const INITIAL_STATE: OfferReducerState = {
  productOffers: [],
  thresholdOffer: null,
  bngmOffers: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OFFERS_UPDATED:
      return {
        ...state,
        productOffers: _.filter(
          action.payload,
          (offer) =>
            getOfferConfigProducts(offer.config)?.length ||
            offer.type ===
              MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT,
        ),
        thresholdOffer: _.find(
          action.payload,
          (offer) => offer.config.threshold,
        ),
        bngmOffers: _.filter(action.payload, (offer) =>
          isBngmOptionListOffer(offer),
        ),
      };
    case CLEAR_OFFERS:
      return INITIAL_STATE;
    default:
      return state;
  }
};
